var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighestEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8125 8.70459C0.8125 4.28631 4.39422 0.70459 8.8125 0.70459H32.8125C37.2308 0.70459 40.8125 4.28631 40.8125 8.70459V32.7046C40.8125 37.1229 37.2308 40.7046 32.8125 40.7046H8.8125C4.39422 40.7046 0.8125 37.1229 0.8125 32.7046V8.70459Z",
    fill: "#E9FDF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.8125, 12.70459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0054 11.0186C12.8137 11.0186 12.6221 10.9912 12.4305 10.9091L4.95703 8.30841V13.0443C4.95703 13.2086 5.01178 13.3728 5.14866 13.455C5.25816 13.5645 7.94094 15.8914 13.0054 15.8914C18.0698 15.8914 20.7526 13.5645 20.8621 13.455C20.9716 13.3455 21.0537 13.1812 21.0537 13.0443V8.30841L13.5803 10.9091C13.3886 10.9638 13.197 11.0186 13.0054 11.0186Z",
    fill: "#21B573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5959 4.33899L13.2223 0.041063C13.0854 -0.0136877 12.9485 -0.0136877 12.8116 0.041063L0.41063 4.33899C-0.136877 4.53061 -0.136877 5.3245 0.41063 5.5435L12.7843 9.84142C12.9211 9.89617 13.058 9.89617 13.1949 9.84142L23.4059 6.28263V8.99279L22.7489 9.43079C22.612 9.54029 22.5025 9.70455 22.5025 9.89617V11.3744C22.5025 11.6756 22.7489 11.9219 23.05 11.9219H24.8568C25.1579 11.9219 25.4043 11.6756 25.4043 11.3744V9.89617C25.4043 9.70455 25.3222 9.54029 25.1579 9.43079L24.5009 8.99279V5.89938L25.5412 5.5435C26.1434 5.3245 26.1434 4.53061 25.5959 4.33899Z",
    fill: "#21B573"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighestEducation);
export default __webpack_public_path__ + "static/media/highest-education.17e6b6df5a9a3dfd22e44a71b8976b31.svg";
export { ForwardRef as ReactComponent };